<template>
  <div>
    <header class="header">
      <!-- vue sidebar menu start -->
      <b-sidebar
        id="sidebar-backdrop"
        ref="sidebarBackdropRef"
        :backdrop-variant="'dark'"
        backdrop
        shadow
        class="customSidebar"
        :sidebar-class="['navbar']"
        right
        no-enforce-focus
        aria-labelledby="sidebar-header"
        aria-label="sidebar"
      >
        <template #header="{ hide }">
          <div class="navbar-collapse" @click="hide">
            <div class="content">
              <button class="navbar-toggler close" type="button" aria-label="Toggle navigation" aria-controls="sidebarNavbar">
                <span class="navbar-toggler-icon"></span>
              </button>
            </div>
          </div>
        </template>
        <div id="sidebarNavbar" class="collapse navbar-collapse">
          <div class="content">
            <div class="fbody">
              <div class="row justify-content-end border-bottom pb-3">
                <div class="col-auto">
                  <!-- <button class="btn btn-signin dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">ÜYE GİRİŞİ</button> -->
                  <div class="dropdown signInHome">
                    <router-link
                      v-if="loggedIn"
                      to="/kullanici-bilgisi"
                      tag="button"
                      class="btn btn-signin dropdown-toggle"
                      type="button"
                      aria-expanded="false"
                    >
                      <!--{{ user.crmMusteriDVO.adSoyad }}-->
                      {{ user.company ? user.companyName : user.firstName }} {{ user.lastName }}
                    </router-link>
                    <button v-else class="btn btn-signin dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                      {{ $t("base-sign-in") }}
                    </button>
                    <div id="dropDownSideBar" class="dropdown-menu">
                      <validation-observer ref="loginRefName" slim>
                        <form @submit.prevent="login('dropDownSideBar')">
                          <validation-provider
                            ref="inputEposta"
                            v-slot="validationContext"
                            :custom-messages="{ required: $t('base-validation'), regex: $t('base-is-valid-mail') }"
                            :rules="{ required: true, regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ }"
                            slim
                          >
                            <div class="form-group" :class="[validationContext.errors.length > 0 ? 'error' : null]">
                              <label>
                                {{ $t("base-mail") }}
                                <span>*</span>
                              </label>
                              <input
                                v-model="email"
                                class="form-control"
                                type="email"
                                :class="[validationContext.errors.length > 0 ? 'is-invalid' : null]"
                                :name="$t('base-mail')"
                              />
                              <div v-if="validationContext.errors.length > 0" class="invalid-feedback-inline">
                                {{ validationContext.errors[0] ? validationTextFormat(validationContext.errors[0]) + "." : null }}
                              </div>
                            </div>
                          </validation-provider>
                          <validation-provider
                            ref="passwordValid"
                            v-slot="validationContext"
                            :custom-messages="{ required: $t('base-validation') }"
                            :rules="{ required: true }"
                            slim
                          >
                            <div class="form-group error">
                              <label>
                                {{ $t("base-password") }}
                                <span>*</span>
                              </label>
                              <div class="inputPassword inputPasswordToggle">
                                <input
                                  v-model="password"
                                  :class="[validationContext.errors.length > 0 ? 'is-invalid' : null]"
                                  class="form-control"
                                  :type="passwordType"
                                />
                                <img
                                  v-if="passwordType === 'password'"
                                  src="/src/images/icon-feather-eye.svg"
                                  class="passwordImg"
                                  alt="icon-feather-eye"
                                  @click="passwordShow('password')"
                                />
                                <img
                                  v-if="passwordType === 'text'"
                                  src="/src/images/icon-feather-eye-off.svg"
                                  class="passwordImg"
                                  alt="icon-feather-eye-off"
                                  @click="passwordShow('text')"
                                />
                              </div>
                              <div v-show="validationContext.errors.length > 0" class="invalid-feedback-inline">
                                {{ validationContext.errors[0] ? validationTextFormat(validationContext.errors[0]) + "." : null }}
                              </div>
                            </div>
                          </validation-provider>
                          <div class="row justify-content-between customRow15">
                            <div class="col-auto customPadding15">
                              <div class="form-group form-check pl-0 passengerCheckBox ticketInformation" data-toggle="buttons">
                                <label class="checkboxArea btn">
                                  <span class="checkboxText">{{ $t("base-remember-me") }}</span>
                                  <input type="checkbox" />
                                  <span class="checkmark"></span>
                                </label>
                              </div>
                            </div>
                            <div class="col-auto customPadding15">
                              <a href="" class="link" data-toggle="modal" data-target="#forgotPassword">{{ $t("base-forgot-password") }}</a>
                            </div>
                          </div>
                          <div class="form-group">
                            <button class="btn btnSign d-flex justify-content-center align-items-center" :type="'submit'" :disabled="loadingLogin">
                              <template v-if="loadingLogin">
                                <b-spinner class="mr-1" small />
                                <span class="sr-only">{{ $t("base-loading") }}</span>
                              </template>
                              {{ $t("base-login") }}
                            </button>
                          </div>
                          <div class="form-group">
                            <button type="button" class="btn btnEdevlet" @click="loginWithEDevlet()">{{ $t("base-login-with-edevlet") }}</button>
                          </div>
                          <div class="form-group mb-0">
                            <p class="noAccount mb-0">
                              <a class="ml-0" href="#" selenium-test="signup" @click="register()">{{ $t("base-new-member-register") }}</a>
                            </p>
                          </div>
                        </form>
                      </validation-observer>
                    </div>
                  </div>
                </div>
              </div>
              <ul class="navbar-nav mr-auto">
                <li class="nav-item active">
                  <router-link tag="a" to="/" class="nav-link" @click.native="$refs.sidebarBackdropRef.hide()">
                    {{ $t("base-buy-ticket") }}
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/trenim-nerede" tag="a" class="nav-link" @click.native="$refs.sidebarBackdropRef.hide()">
                    {{ $t("train-tracking-title") }}
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link tag="a" to="/yardim" class="nav-link" @click.native="$refs.sidebarBackdropRef.hide()">
                    {{ $t("base-solution-center") }}
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link tag="a" to="/engelsiz-ulasim" class="nav-link" @click.native="$refs.sidebarBackdropRef.hide()">
                    {{ $t("base-barrier-free-transportation") }}
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link tag="a" to="/turistik-trenler" class="nav-link" @click.native="$refs.sidebarBackdropRef.hide()">
                    {{ $t("tourist-trains") }}
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link tag="a" to="/iletisim" class="nav-link" @click.native="$refs.sidebarBackdropRef.hide()">
                    {{ $t("base-contact") }}
                  </router-link>
                </li>
                <!--                <li class="nav-item">-->
                <!--                  <router-link-->
                <!--                    tag="a"-->
                <!--                    to="/acik-biletlerim"-->
                <!--                    class="nav-link"-->
                <!--                    >-->
                <!--                      Açık Biletlerim-->
                <!--                  </router-link>-->
                <!--                </li>-->
                <!-- <li class="nav-item">
                  <a class="nav-link" href="#">Bölgesel Trenler</a>
                </li> -->
                <li class="nav-item">
                  <a href="https://www.tcddtasimacilik.gov.tr/sayfa/yolcunun-el-kilavuzu/" class="nav-link" target="_blank">{{ $t("base-passenger-right") }}</a>
                </li>

                <li class="nav-item">
                  <router-link tag="a" to="/yolcu-tasima-kurallari" class="nav-link" @click.native="$refs.sidebarBackdropRef.hide()">
                    {{ $t("base-passenger-transport-rules") }}
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/yardim-talep-formu" tag="a" class="nav-link" @click.native="$refs.sidebarBackdropRef.hide()">
                    {{ $t("base-footer-help-request-form") }}
                  </router-link>
                </li>
                <!--<li class="nav-item">-->
                <!--  <router-link to="/tren-kart-arama" tag="a" class="nav-link">-->
                <!--    Tren Kart Arama-->
                <!--  </router-link>-->
                <!--</li>-->
                <li v-if="showInterrailMenuItemByEnvironment" class="nav-item">
                  <router-link to="/interrail-eurail-pass" tag="a" class="nav-link" @click.native="$refs.sidebarBackdropRef.hide()">
                    {{ $t("interrail-eurail-package-transactions-menu-text") }}
                  </router-link>
                </li>
                <li v-if="Object.keys(user).length > 0" class="nav-item">
                  <a class="nav-link" href="#" @click="logout()">{{ $t("base-exit") }}</a>
                </li>
              </ul>
            </div>

            <div class="fmenu">
              <a href="https://wa.me/905073218233" target="_blank" class="whatsApp">{{ $t("base-whatsapp") }}</a>
              <a href="tel:4448233" target="_blank" class="callCenter">{{ $t("base-call-center") }}</a>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </b-sidebar>
      <!-- vue sidebar menu end -->
      <!-- menu start-->
      <nav class="navbar navbar-light">
        <router-link tag="a" to="/" class="navbar-brand">
          <img src="/src/images/tcdd-logo.png" alt="tcdd-logo" loading="lazy" />
          <!-- <img :src="basePath+'/images/tcdd-logo.png'" alt="tcdd-logo" /> -->
        </router-link>
        <div class="menu mr-auto">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item active">
              <router-link tag="a" to="/" class="nav-link" @keydown.native="goToFromInput($event)" @click.native="$refs.sidebarBackdropRef.hide()">
                {{ $t("base-buy-ticket") }}
              </router-link>
            </li>
            <li class="nav-item active">
              <router-link tag="a" to="/trenim-nerede" class="nav-link" @click.native="$refs.sidebarBackdropRef.hide()">
                {{ $t("train-tracking-title") }}
              </router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link
                tag="a"
                to="/acik-biletlerim"
                class="nav-link"
                >
                  Açık Biletlerim
              </router-link>
            </li> -->
            <li class="nav-item">
              <router-link tag="a" to="/yardim" class="nav-link" aria-flowto="testFlow" @click.native="$refs.sidebarBackdropRef.hide()">
                {{ $t("base-solution-center-2") }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link tag="a" to="/engelsiz-ulasim" class="nav-link" aria-flowto="testFlow" @click.native="$refs.sidebarBackdropRef.hide()">
                {{ $t("base-barrier-free-transportation-2") }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link tag="a" to="/iletisim" class="nav-link" @click.native="$refs.sidebarBackdropRef.hide()">
                {{ $t("base-contact-2") }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link tag="a" to="/turistik-trenler" class="nav-link" @click.native="$refs.sidebarBackdropRef.hide()">
                {{ $t("tourist-trains") }}
              </router-link>
            </li>
          </ul>
          <div class="dropdown signInHome" selenium-test="user-name-last-name">
            <router-link
              v-if="loggedIn"
              to="/kullanici-bilgisi"
              tag="button"
              class="btn btn-signin dropdown-toggle"
              type="button"
              aria-expanded="false"
              @click.native="$refs.sidebarBackdropRef.hide()"
            >
              <!--{{ user.crmMusteriDVO.adSoyad }}-->
              {{ user.firstName }} {{ user.lastName }}
            </router-link>
            <!--            <button v-if="loggedIn" class="btn btn-signin dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"> </button>-->
            <button
              v-else
              id="btnLogin"
              class="btn btn-signin dropdown-toggle"
              selenium-test="signin-open-popup"
              type="button"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              {{ $t("base-sign-in") }}
            </button>

            <div id="dropDownMainPage" class="dropdown-menu">
              <validation-observer ref="loginRefName" slim>
                <form @submit.prevent="login('dropDownMainPage')">
                  <validation-provider
                    ref="inputEposta"
                    v-slot="validationContext"
                    :custom-messages="{ required: $t('base-validation'), regex: $t('base-is-valid-mail') }"
                    :rules="{ required: true, regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ }"
                    slim
                  >
                    <div class="form-group" :class="[validationContext.errors.length > 0 ? 'error' : null]">
                      <label>
                        {{ $t("base-mail") }}
                        <span>*</span>
                      </label>
                      <input
                        v-model="email"
                        class="form-control"
                        type="email"
                        selenium-test="signin-mail"
                        :class="[validationContext.errors.length > 0 ? 'is-invalid' : null]"
                        :name="$t('base-mail')"
                        @keypress="preventSpace($event)"
                        @input="trimSpaces(email)"
                        @paste="handlePaste($event, email)"
                      />
                      <div v-if="validationContext.errors.length > 0" class="invalid-feedback-inline">
                        {{ validationContext.errors[0] ? validationTextFormat(validationContext.errors[0]) + "." : null }}
                      </div>
                    </div>
                  </validation-provider>
                  <validation-provider
                    ref="passwordValid"
                    v-slot="validationContext"
                    :custom-messages="{ required: $t('base-validation') }"
                    :rules="{ required: true }"
                    slim
                  >
                    <div class="form-group error">
                      <label>
                        {{ $t("base-password") }}
                        <span>*</span>
                      </label>
                      <div class="inputPassword inputPasswordToggle">
                        <input
                          v-model="password"
                          :class="[validationContext.errors.length > 0 ? 'is-invalid' : null]"
                          selenium-test="signin-password"
                          class="form-control"
                          :type="passwordType"
                        />
                        <img
                          v-if="passwordType === 'password'"
                          src="/src/images/icon-feather-eye.svg"
                          class="passwordImg"
                          alt="icon-feather-eye"
                          @click="passwordShow('password')"
                        />
                        <img
                          v-if="passwordType === 'text'"
                          src="/src/images/icon-feather-eye-off.svg"
                          class="passwordImg"
                          alt="icon-feather-eye-off"
                          @click="passwordShow('text')"
                        />
                      </div>
                      <div v-show="validationContext.errors.length > 0" class="invalid-feedback-inline">
                        {{ validationContext.errors[0] ? validationTextFormat(validationContext.errors[0]) + "." : null }}
                      </div>
                    </div>
                  </validation-provider>
                  <div class="row justify-content-between">
                    <div class="col-auto">
                      <div class="form-group form-check pl-0 passengerCheckBox ticketInformation" data-toggle="buttons">
                        <label class="checkboxArea btn">
                          <span class="checkboxText">{{ $t("base-remember-me") }}</span>
                          <input v-model="rememberMe" type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-auto">
                      <a href="" class="link" data-toggle="modal" data-target="#forgotPassword">{{ $t("base-forgot-password") }}</a>
                    </div>
                  </div>
                  <div class="form-group">
                    <button
                      class="btn btnSign d-flex justify-content-center align-items-center"
                      selenium-test="signin"
                      :type="'submit'"
                      :disabled="loadingLogin"
                    >
                      <template v-if="loadingLogin">
                        <b-spinner class="mr-1" small />
                        <span class="sr-only">{{ $t("base-loading") }}</span>
                      </template>
                      {{ $t("base-login") }}
                    </button>
                  </div>
                  <div class="form-group">
                    <button type="button" class="btn btnEdevlet" @click="loginWithEDevlet()">{{ $t("base-login-with-edevlet") }}</button>
                  </div>
                  <div class="form-group mb-0">
                    <p class="noAccount mb-0">
                      <a class="ml-0" href="#" selenium-test="signup" @click="register()">{{ $t("base-new-member-register") }}</a>
                    </p>
                  </div>
                </form>
              </validation-observer>
            </div>
          </div>
          <div class="dropdown lang">
            <button class="btn btn-lang" type="button" data-toggle="dropdown" aria-expanded="false">{{ $i18n.locale.toUpperCase() }}</button>
            <div class="dropdown-menu">
              <a class="dropdown-item" href="#" @click="switchLanguage('tr')">Türkçe</a>
              <a class="dropdown-item" href="#" @click="switchLanguage('en')">English</a>
              <a class="dropdown-item" href="#" @click="switchLanguage('fa')">فارسی</a>
            </div>
          </div>
        </div>
        <!-- menu button click -->
        <button v-b-toggle.sidebar-backdrop class="navbar-toggler" type="button" aria-label="Toggle navigation" aria-controls="sidebarNavbar">
          <span class="navbar-toggler-icon"></span>
        </button>
      </nav>
      <!-- menu end-->
    </header>
    <!-- modal start -->
    <!-- Yeni Üye-->
    <div id="newUser" class="modal fade rightHandModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
            <h6 class="modal-title">{{ $t("base-new-member-register") }}</h6>
          </div>
          <div class="modal-body">
            <user-register-component ref="userRegisterComponent" />
          </div>
        </div>
      </div>
    </div>
    <!-- şifremi Unuttum modal-->
    <div id="forgotPassword" class="modal fade seferModal modalMilArea" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <validation-observer ref="forgotPasswordObserver" slim>
            <form @submit.prevent="resetPasswordGenerateCode()">
              <div class="modal-header">
                <div class="row no-gutters">
                  <div class="col-12">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="col-12">
                    <h6 class="modal-title">{{ $t("base-forgot-password") }}</h6>
                  </div>
                </div>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-12">
                    <p>{{ $t("base-change-password") }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <validation-provider
                      ref="userMail"
                      v-slot="validationContext"
                      :custom-messages="{ required: $t('required-field'), regex: $t('invalid-email') }"
                      :rules="{ required: true, regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ }"
                      slim
                    >
                      <div class="form-group" :class="[validationContext.errors.length > 0 ? 'error' : null]">
                        <div class="userMail">
                          <label>{{ $t("base-e-mail") }}</label>
                          <input
                            v-model="userMail"
                            :class="[validationContext.errors.length > 0 ? 'is-invalid' : null]"
                            class="form-control is-invalid"
                            type="text"
                            @keypress="preventSpace($event)"
                            @input="trimSpaces(userMail)"
                            @paste="handlePaste($event, userMail)"
                          />
                          <div v-show="validationContext.errors.length > 0" class="invalid-feedback-inline">
                            {{ validationContext.errors[0] ? validationTextFormat(validationContext.errors[0]) : null }}
                          </div>
                        </div>
                      </div>
                    </validation-provider>
                  </div>
                  <div class="col-auto btnMilArea mt-0">
                    <div class="form-group mb-0">
                      <label class="invisible">empty</label>
                    </div>
                    <button type="submit" class="btn btn-primary">{{ $t("base-send") }}</button>
                  </div>
                </div>
              </div>
            </form>
          </validation-observer>
        </div>
      </div>
    </div>
    <!-- userActivation modal-->
    <div id="userActivation" class="modal fade seferModal modalWarning" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable scrollbar">
        <div class="modal-content">
          <div class="modal-header">
            <div class="row no-gutters">
              <div class="col-12">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="col-12">
                <h6 class="modal-title fontSize">{{ $t("base-message-v1") }}</h6>
                <p class="mt-4">{{ $t("base-active-message-v2") }}</p>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col-12 d-flex">
                <img src="/src/images/icon-modal-warning.svg" class="img-fluid imgWarning" alt="icon-modal-warning" />
                <p class="text-left">
                  {{ $t("base-active-message-v3") }}
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t("base-send-again") }}</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal">{{ $t("base-login") }}</button>
          </div>
        </div>
      </div>
    </div>
    <base-alert />
    <loading :active.sync="loadingFullPage" :is-full-page="true" />
  </div>
</template>

<script>
import moment from "moment";
import "../vue2-daterange-picker/dist/vue2-daterange-picker.css";
import BaseAlert from "../../components/element/BaseAlert";
import ServiceResponseHelper from "../../mixins/serviceResponseHelper";
import zxcvbn from "zxcvbn";
import UserRegisterComponent from "../sefer/UserRegisterComponent.vue";
import LogoutMixin from "../../mixins/logoutMixin";
import Loading from "vue-loading-overlay";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { loadLanguageAsync } from "../../plugins/i18n";
import analytics from "../../plugins/analytics";
import { storeAuthTokens } from "../../util/authTokenStorage";
import resetPasswordErrorLogger from "../../util/resetPasswordErrorLogger.js";
import Vue from "vue";
import { SidebarPlugin, SpinnerPlugin, VBTogglePlugin } from "bootstrap-vue";

Vue.use(SidebarPlugin);
Vue.use(SpinnerPlugin);
// Note: Vue automatically prefixes the directive name with 'v-'
Vue.use(VBTogglePlugin);

export default {
  name: "BaseHeader",
  components: { UserRegisterComponent, BaseAlert, Loading },
  filters: {
    dateInputText(val) {
      return val ? moment(val).format("YYYY-MM-DD") : "";
    },
    dateCell(value) {
      let date = new Date(value);
      return date.getDate();
    },
    dateCellToString(value) {
      let date = new Date(value);
      return moment(date).format("DD-MM-YYYY");
    },
  },
  mixins: [ServiceResponseHelper, LogoutMixin],
  data() {
    return {
      dateBorderClass: false,
      dateRange: {
        startDate: null,
        endDate: null,
      },
      dateRangeView: {
        startDate: null,
        endDate: null,
      },
      localeData: {
        direction: "ltr",
        format: "dd/mm/yyyy",
        separator: " - ",
        daysOfWeek: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],
        monthNames: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],
        firstDay: 1,
      },
      startDateInput: null,
      endDateInput: null,
      minDate: null,
      maxDate: null,
      prevMonthEl: null,
      nextMonthEl: null,
      email: null,
      password: null,
      userMail: null,
      passwordMinCharacter: 8,
      dangerUpperCase: null,
      dangerLowerCase: null,
      dangerNumberCase: null,
      dangerCharacter: null,
      successUpperCase: null,
      successLowerCase: null,
      successNumberCase: null,
      successCharacter: null,
      passwordValid: false,
      passwordLevel: null,
      passwordStrong: null,
      loadingLogin: false,
      rememberMe: false,
      passwordType: "password",
      code: null,
      loadingCustomer: false,
      loadingResetPasswordGenerateCode: false,
      loadingForgetMyPassword: false,
      loadingEDevlet: false,
    };
  },
  computed: {
    customerInformation: {
      get() {
        return this.$store.getters.getCustomerInformation;
      },
      set(val) {
        this.$store.commit("setCustomerInformation", val);
      },
    },
    loggedIn: {
      get() {
        return this.$store.getters.getLoggedIn;
      },
    },
    user: {
      get() {
        return this.$store.getters.getUser;
      },
      set(val) {
        this.$store.commit("setUser", val);
      },
    },
    currentRouteName() {
      return this.$route.name;
    },
    basePath: {
      get() {
        return this.$store.getters.getBasePath;
      },
    },
    loadingFullPage() {
      return this.loadingCustomer || this.loadingLogin || this.loadingForgetMyPassword || this.loadingResetPasswordGenerateCode || this.loadingEDevlet;
    },
    language() {
      return this.$store.getters.getLanguage;
    },
    environment: {
      get() {
        return this.$store.getters.getEnvironment;
      },
    },
    showInterrailMenuItemByEnvironment() {
      return this.environment === "LOCAL-DEV" || this.environment === "LOCAL-UAT" || this.environment === "PROD-DEV" || this.environment === "PROD-UAT";
    },
  },
  created() {
    // Sayfa yüklendiğinde localStorage'da kullanıcı bilgilerini kontrol et
    const storedEncryptedEmail = localStorage.getItem("email");
    const storedEncryptedPassword = localStorage.getItem("password");

    if (storedEncryptedEmail && storedEncryptedPassword) {
      const encryptionKey = "myEncryptionKey"; // Şifreleme anahtarı
      const decryptedUsername = this.decryptData(storedEncryptedEmail, encryptionKey);
      const decryptedPassword = this.decryptData(storedEncryptedPassword, encryptionKey);

      this.email = decryptedUsername;
      this.password = decryptedPassword;
      this.rememberMe = true;
    }
  },
  mounted() {
    this.checkForEdevletLogin();
    const vm = this;
    $("#forgotPassword").on("hidden.bs.modal", function (event) {
      vm.$refs.forgotPasswordObserver.reset();
    });

    // html de tanımlı dili belirleme start
    this.$i18n.locale = this.language;
    document.documentElement.setAttribute("lang", this.language);
    // html de tanımlı dili belirleme end

    this.onLoginSuccessLandingSubscriptionOrDiscountPackage();
  },
  watch: {
    loggedIn(newVal) {
      if (!newVal) {
        this.email = null;
        this.password = null;
        this.rememberMe = false;
        this.loadingLogin = false;
        this.$nextTick(() => {
          if (this.$refs.loginRefName) {
            this.$refs.loginRefName.reset();
          }
        });
      }
    },
  },
  methods: {
    switchLanguage(language) {
      loadLanguageAsync(language).then(() => {
        window.location.reload();
      });
    },
    checkForEdevletLogin() {
      const params = new URLSearchParams(window.location.search);
      let code = params.get("code");
      let state = params.get("state");
      let request = {};
      request.code = code;
      request.state = state;
      if (code && state) {
        this.$store.dispatch("loginWithEDevlet", request).then((res) => {
          if (res.status !== 200) {
            this.callAlert(4, this.$t("login-could-not-be-made"), "danger", this.$t("invalid-login"));
            const currentUrl = window.location.origin + window.location.pathname;
            // Parametreleri silerek URL'yi güncelle
            window.history.pushState({}, "", currentUrl);
            return;
          }
          let response = this.transformResponse(res.data); // userModel to user
          this.user = this.createUserData(response.userModel, response.userLoginResponse);
          storeAuthTokens(response.userLoginResponse);
          // GA4: hash'li user_id + login event (e-Devlet girişi).
          try {
            Promise.resolve(analytics.setUser(this.user.userId)).finally(() => analytics.login("e-devlet"));
          } catch (e) {
            /* analytics akışı bozmaz */
          }
          this.callAlert(4, this.$t("successfully-logged-in"), "success", this.$t("success-transaction"));
          // this.loadCustomer(response);
          response.customerNo = response.userModel.nationalityCountryId === 1 ? response.userModel.citizenshipNo : response.userModel.passportNo;
          this.customerInformation = this.createUserInformationModel(response.userModel);
          // this.$store.commit("setCustomerInformation",this.customerInformation);
          this.$refs.sidebarBackdropRef.hide();
        });
      }
    },
    transformResponse(response) {
      return {
        ...response,
        user: response.userModel,
      };
    },
    createUserData(userModel, loginResponse) {
      return {
        userId: userModel.id,
        firstName: userModel.firstName,
        lastName: userModel.lastName,
        email: userModel.email,
        companyName: userModel.companyName,
        company: userModel.company,
        accessToken: loginResponse.accessToken,
        userUnits: userModel.units || [], // Eğer `units` null ise boş bir dizi
      };
    },
    createUserInformationModel(userModel) {
      return {
        id: userModel.id || null,
        intents: null, // Varsayılan değer
        intentId: 0, // Varsayılan değer
        userId: 0, // Varsayılan değer
        username: null, // Varsayılan değer
        lastUpdateDate: null, // Varsayılan değer
        published: false, // Varsayılan değer
        updated: false, // Varsayılan değer
        user: {
          id: userModel.id,
          firstName: userModel.firstName,
          lastName: userModel.lastName,
          email: userModel.email,
          companyName: userModel.companyName,
          company: userModel.company,
          units: userModel.units || [],
          status: userModel.status,
          statusReason: userModel.statusReason,
          statusReasonDescription: userModel.statusReasonDescription,
          type: userModel.type,
          gender: userModel.gender,
          citizenshipNo: userModel.citizenshipNo,
          nationalityCountryId: userModel.nationalityCountryId,
          passportNo: userModel.passportNo,
          mobileNumberCountryCode: userModel.mobileNumberCountryCode,
          mobileNumber: userModel.mobileNumber,
          birthdate: userModel.birthdate,
          taxNo: userModel.taxNo,
          taxAdministration: userModel.taxAdministration,
          createDate: userModel.createDate,
        },
      };
    },
    resetPasswordGenerateCode() {
      this.$refs.forgotPasswordObserver.validate().then((success) => {
        if (!success) {
          this.callAlert(4, this.$t("please-fill-required-field"), "danger", this.$t("failed-transaction-title-v2"));
        } else {
          let request = {
            username: this.userMail,
          };
          this.loadingResetPasswordGenerateCode = true;
          let startedAt = Date.now();
          let logExtra = { email: resetPasswordErrorLogger.maskEmail(request.username) };
          this.$store
            .dispatch("resetPasswordGenerateCode", request)
            .then((response) => {
              if (!response) {
                // Store action hatayı yuttuğu için HTTP yanıtı hiç gelmeyen durumlar (bağlantı kopması, CORS, engelleme) buraya düşüyor.
                resetPasswordErrorLogger.log("GENERATE_CODE", "NETWORK", { startedAt, extra: logExtra });
                this.callAlert(4, this.$t("failed-transaction-v4"), "danger", this.$t("failed-transaction-title-v2"));
              } else if (response.status && response.status !== 200) {
                resetPasswordErrorLogger.log("GENERATE_CODE", "HTTP", { response, startedAt, extra: logExtra });
                // Gövde JSON değilse (istio/ingress hata sayfası) mesaj boş kalıp ekranda boş uyarı çıkıyordu.
                this.callAlert(4, response.data?.message || this.$t("failed-transaction-v4"), "danger", this.$t("failed-transaction-title-v2"));
              } else {
                this.callAlert(4, this.$t("password-reset-message", [`${request.username}`]), "success", this.$t("successful-transaction"));
                $("#forgotPassword").modal("hide");
              }
            })
            .finally(() => {
              this.loadingResetPasswordGenerateCode = false;
              $(".selectpicker").selectpicker("refresh");
            })
            .catch((err) => {
              resetPasswordErrorLogger.log("GENERATE_CODE", "CLIENT_EXCEPTION", { error: err, startedAt, extra: logExtra });
              this.loadingResetPasswordGenerateCode = false;
              this.callAlert(4, this.$t("failed-transaction-v4"), "danger", this.$t("failed-transaction-title-v2"));
            });
        }
      });
    },
    passwordShow(param) {
      if (param === "password") {
        this.passwordType = "text";
      } else if (param === "text") {
        this.passwordType = "password";
      }
    },
    goToFromInput(event) {
      if (event.defaultPrevented) {
        return; // Should do nothing if the default action has been cancelled
      }
      let handled = false;
      if (event.key === "Enter") {
        $("#fromTrainInput").focus();
      }
    },

    checkPasswordRules() {
      if (this.dangerUpperCase !== null || this.dangerLowerCase !== null || this.dangerCharacter !== null || this.dangerNumberCase !== null) {
        this.passwordValid = false;
        if (this.password === "") {
          this.$refs.passwordValid.applyResult({
            errors: [this.$t("required-field-v2")],
            valid: false,
            failedRules: {},
          });
        } else {
          this.$refs.passwordValid.applyResult({
            errors: [""],
            valid: false,
            failedRules: {},
          });
        }
      } else {
        this.passwordValid = true;
      }
    },
    passwordStrength() {
      if (zxcvbn(this.password).score <= 2) {
        this.passwordStrong = this.$t("password-weak");
        return (this.passwordLevel = "text-danger");
      } else if (zxcvbn(this.password).score === 3) {
        this.passwordStrong = this.$t("password-medium");
        return (this.passwordLevel = "text-warning");
      } else if (zxcvbn(this.password).score >= 4) {
        this.passwordStrong = this.$t("password-strong");
        return (this.passwordLevel = "text-success");
      }
    },
    minPasswordCharacterSuccess() {
      if (this.password?.toString().length >= 8) {
        this.successCharacter = "bg-success";
        this.dangerCharacter = null;
      } else return (this.successCharacter = null);
    },
    includeOneUpperCase() {
      if (this.password?.match(/[A-ZİŞĞÇÖÜ]/g) !== null) {
        this.successUpperCase = "bg-success";
        this.dangerUpperCase = null;
      } else {
        return (this.successUpperCase = null);
      }
    },
    includeOneLowerCase() {
      if (this.password?.match(/[a-zışğçöü]/g) !== null) {
        this.successLowerCase = "bg-success";
        this.dangerLowerCase = null;
      } else {
        return (this.successLowerCase = null);
      }
    },
    includeOneNumber() {
      if (this.password?.match(/[0-9]/g) !== null) {
        this.successNumberCase = "bg-success";
        this.dangerNumberCase = null;
      } else {
        return (this.successNumberCase = null);
      }
    },
    minPasswordCharacterDanger() {
      if (this.password?.toString().length < 8) {
        return (this.dangerCharacter = "bg-danger");
      } else {
        return (this.dangerCharacter = null);
      }
    },
    notIncludeOneUpperCase() {
      if (this.password?.match(/[A-ZİŞĞÇÖÜ]/g) === null) {
        return (this.dangerUpperCase = "bg-danger");
      } else {
        return (this.dangerUpperCase = null);
      }
    },
    notIncludeOneLowerCase() {
      if (this.password?.match(/[a-zışğçöü]/g) === null) {
        return (this.dangerLowerCase = "bg-danger");
      } else {
        return (this.dangerLowerCase = null);
      }
    },
    notIncludeOneNumber() {
      if (this.password?.match(/[0-9]/g) === null) {
        return (this.dangerNumberCase = "bg-danger");
      } else {
        return (this.dangerNumberCase = null);
      }
    },
    validationTextFormat(text) {
      let fiterText = text.split(" ");
      let returnText = fiterText[0];
      for (let i = 1; i < fiterText.length; i++) {
        returnText += " " + fiterText[i].charAt(0).replace(/İ/gim, "i").toLowerCase() + fiterText[i].slice(1).toLowerCase();
      }
      return returnText;
    },
    toggleBorderClass(value) {
      this.dateBorderClass = value;
    },
    login(dropDownId) {
      this.$refs.loginRefName.validate().then((success) => {
        if (!success) {
          this.callAlert(4, this.$t("please-fill-required-field"), "danger", this.$t("failed-transaction"));
          return;
        }
        let request = {};
        request.username = this.email;
        request.password = this.password;

        this.loadingLogin = true;
        this.$store
          .dispatch("login", request)
          .then((response) => {
            this.loadingLogin = false;
            // Store action returns error response when login fails, check for HTTP error status
            if (response && response.status && response.status >= 400) {
              let errorMessage = this.$t("base-please-check-your-member-details");
              if (response.data && response.data.message) {
                errorMessage = response.data.message;
              }
              this.callAlert(4, errorMessage, "danger", this.$t("failed-transaction"));
              return;
            }
            if (this.rememberMe) {
              const encryptionKey = "myEncryptionKey"; // Şifreleme anahtarı

              const storedEmail = localStorage.setItem("email", this.encryptData(this.email, encryptionKey));
              const storedPassword = localStorage.setItem("password", this.encryptData(this.password, encryptionKey));
              if (storedEmail && storedPassword) {
                // localStorage'dan alınan kullanıcı bilgilerini input alanlarına doldur
                this.email = storedEmail;
                this.password = storedPassword;
              }
            }
            this.user = JSON.parse(JSON.stringify(response));
            storeAuthTokens(response);

            this.$store.commit("setUser", response);
            // GA4: hash'li user_id + login event (setUser sonrası login).
            try {
              Promise.resolve(analytics.setUser(this.user.userId)).finally(() => analytics.login("site"));
            } catch (e) {
              /* analytics akışı bozmaz */
            }
            this.callAlert(4, this.$t("successfully-logged-in"), "success", this.$t("success-transaction"));
            $("#" + dropDownId).dropdown("hide");
            this.loadCustomer(response);
            this.$refs.sidebarBackdropRef.hide();
            this.onLoginSuccessLandingSubscriptionOrDiscountPackage();
          })
          .catch((error) => {
            this.loadingLogin = false;
            let errorMessage = this.$t("base-please-check-your-member-details");
            if (error && error.data && error.data.message) {
              errorMessage = error.data.message;
            }
            this.callAlert(4, errorMessage, "danger", this.$t("failed-transaction"));
          })
          .finally(() => {
            this.loadingLogin = false;
          });
      });
    },
    register() {
      this.resetUserInformationForRegister();
      this.$refs.userRegisterComponent.$refs.register.reset();
      // Telefon uyarisini sifirla: modal ilk acildiginda dokunulmamis alanda kirmizi cikmasin.
      this.$refs.userRegisterComponent.phoneValidationTriggered = false;
      $("#newUser").modal("show");
    },
    loginWithEDevlet() {
      this.loadingEDevlet = true;
      this.$store.dispatch("loginWithEDevletGetRedirectURL").then((response) => {
        this.loadingEDevlet = false;
        window.location.href = response;
      });
      // http://uat-st.ditravo.com:8300/e-devlet
    },
    encryptData(data, key) {
      const encryptedData = btoa(key + data);
      return encryptedData;
    },
    decryptData(encryptedData, key) {
      const decryptedData = atob(encryptedData).replace(key, "");
      return decryptedData;
    },
    //clearCode(){
    //  this.code = null;
    //  $("#activationAndSetPassword").modal("hide");
    //  this.$router.replace({ path: '/', query: {} });
    //},
    loadCustomer() {
      this.loadingCustomer = true;
      this.$store
        .dispatch("loadCustomer")
        .then((response) => {
          response.customerNo = response.user.nationalityCountryId === 1 ? response.user.citizenshipNo : response.user.passportNo;
          this.customerInformation = response;
          this.$store.commit("setCustomerInformation", this.customerInformation);
        })
        .finally(() => {
          this.loadingCustomer = false;
        });
    },
    resetUserInformationForRegister() {
      this.isThisAnUpdateCustomer = false;
      this.$store.commit("setSelectedUser", {
        bloodType: {},
        profession: { id: "" },
        user: { taxAdministration: {}, gender: "M" },
        educationStatus: {},
      });
      this.$refs.userRegisterComponent.isTurkish = true;
      this.$refs.userRegisterComponent.isContractApproved = false;
      this.$refs.userRegisterComponent.phoneProps = { preferredCountries: ["TR"] };
      this.$refs.userRegisterComponent.phoneInformationStatus = false;
      this.$refs.userRegisterComponent.phoneNumberCountryObject = {
        name: "Turkey (Türkiye)",
        iso2: "TR",
        dialCode: "90",
      };
      this.$refs.userRegisterComponent.telInputOptions = {
        autocomplete: "new-tel",
        autofocus: false,
        "aria-describedby": "telephone-input",
        maxlength: 13,
        name: "telephone",
        tabindex: 0,
        type: "tel",
        placeholder:
          this.$refs.userRegisterComponent.phoneNumberCountryObject && this.$refs.userRegisterComponent.phoneNumberCountryObject.iso2 === "TR"
            ? "___ ___ __ __"
            : null,
      };
      this.$refs.userRegisterComponent.telInputDropdownOptions = {
        showSearchBox: true,
        showFlags: true,
        showDialCodeInList: true,
        tabindex: 0,
        width: "100%",
        showDialCodeInSelection: true,
      };
      this.$refs.userRegisterComponent.$refs.telInputUserRegisterRef.activeCountryCode = "TR";
      this.$nextTick(() => {
        this.$refs.userRegisterComponent.phoneInformation.phoneNumber = "";
        this.$refs.userRegisterComponent.$refs.inputPhoneNumberUserRegister.reset();
        this.$refs.userRegisterComponent.$refs.register.reset();
        this.$nextTick(() => {
          this.$refs.userRegisterComponent.isPhoneNumberValid = true;
        });
      });
    },
    preventSpace(event) {
      if (event.key === " ") {
        event.preventDefault();
      }
    },
    trimSpaces(email) {
      this.email = this.email.replace(/\s+/g, ""); // Tüm boşlukları kaldırır
    },
    handlePaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData("Text").replace(/\s+/g, "");
      event.preventDefault();
      this.email = pastedData;
    },
    onLoginSuccessLandingSubscriptionOrDiscountPackage() {
      if (this.loggedIn) {
        const redirect = this.$route.query.redirect;
        if (redirect) {
          this.$router.push(redirect);
        }
      } else {
        const redirect = this.$route.query.redirect;
        if (redirect) {
          this.callAlert(4, this.$t("train-card-login"), "danger", this.$t("warning!"));
          $("#btnLogin").click();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.inputPasswordToggle {
  position: relative;

  .form-control {
    padding-right: 40px;
  }

  .passwordImg {
    position: absolute;
    top: 50%;
    margin-top: -10px;
    right: 14px;
    z-index: 1;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}

#activationAndSetPassword {
  .modal-dialog {
    @media (min-width: 575px) {
      width: 500px;
    }
  }
}

.header {
  .navbar {
    .signInHome {
      .dropdown-menu {
        width: 345px;
        @media (max-width: 575px) {
          width: 338px;
        }
      }
    }

    @media (max-width: 1200px) {
      .menu {
        .navbar-nav {
          display: none;
        }
      }
    }
    @media only screen and (min-width: 577px) and (max-width: 1200px) {
      padding: 24px;
    }
    @media (max-width: 992px) {
      .signInHome {
        .btn-signin {
          width: auto;
        }
      }
    }
    @media (max-width: 767px) {
      .signInHome {
        .btn-signin {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 220px;
        }
      }
    }
    @media (max-width: 575px) {
      .signInHome {
        .btn-signin {
          width: 100%;
          max-width: 100%;
        }
      }
    }

    .navbar-toggler {
      &.close {
        &:focus-visible {
          outline: none;
        }
      }
    }

    .navbar-nav {
      .nav-link {
        font-size: 16px;
      }
    }
  }

  @media (max-width: 575px) {
    .customSidebar {
      ::v-deep {
        .b-sidebar {
          background-color: red;

          .b-sidebar-body {
            overflow-y: visible;
          }
        }
      }
    }
  }
}

#forgotPassword {
  .modal-dialog {
    .modal-content {
      .form-control.is-invalid:focus,
      .was-validated .form-control:invalid:focus {
        box-shadow: none;
      }

      @media (max-width: 575px) {
        margin-top: auto;
      }
    }
  }
}

::v-deep {
  #sidebar-backdrop {
    &.navbar .signInHome .dropdown-menu {
      right: -15px;
    }
  }
}

// RTL support
:deep([dir="rtl"]) {
  .dropdown-menu {
    text-align: right;
    left: auto !important;
    right: 0;
  }

  .inputPasswordToggle {
    .form-control {
      padding-right: 12px;
      padding-left: 40px;
    }

    .passwordImg {
      right: auto;
      left: 14px;
    }
  }

  .form-check {
    padding-right: 1.25rem;
    padding-left: 0;
  }

  .invalid-feedback {
    text-align: right;
  }

  .mr-auto {
    margin-left: auto !important;
    margin-right: 0 !important;
  }

  .ml-auto {
    margin-right: auto !important;
    margin-left: 0 !important;
  }

  @media (max-width: 575px) {
    .navbar {
      .menu {
        .dropdown {
          &.lang {
            margin-right: auto;
            margin-left: 0;
          }
        }
      }
    }
  }
}

// todo : ticket-reservation.scss içerisine yazılacak
//.userInformation .seferHeaderText{
//  margin-top: 15px !important;
//}
</style>
